export const visit = (vm, at) => {
at({ "en": { "publicPricingPage": { "anchorCta": { "heading": "Join 306,000+ customers who grow their businesses with HubSpot", "cta": "Get started free" } } } });
};